<template>
  <div>
    <el-form label-position="left" label-width="200px">
      <el-form-item label="URL:">
        <el-input
          class="url"
          v-model="downloadInfo.downloadUrl"
          @click.native.stop.prevent="handleClick('downloadUrl')"
          @touchend.native.stop.prevent="handleClick('downloadUrl')"
        />
      </el-form-item>
      <el-form-item :label="$t('langcfg.txtCompany') + ':'">
        <el-select v-model="downloadInfo.copmany" placeholder="" @change="selectChanged">
          <el-option
            v-for="item in selections"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <br />
    <el-form label-width="200px">
      <el-form-item>
        <el-row>
          <el-col :span="12"
            ><el-button
              class="btn-oprator"
              @click="download()"
              style="font-size: 25px; width: 150px"
              >{{ $t("langcfg.txtDownload") }}</el-button
            ></el-col
          >
          <el-col :span="12">
            <el-button
              class="btn-oprator"
              @click="thirdClick()"
              style="font-size: 25px; width: 150px"
              >{{ $t("langcfg.txtBack") }}</el-button
            >
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import EVENTS from "../../../bus";
import fileSys from "../../../fileoprators/fileSystem";
import { Message } from "../../../mixins";
import { reqGet } from "../../../services/httpreq";
import { initThirdParty, saveSettings } from "../../../settings";
import { logStdout, string2json } from "../../../shared/utils";
const { spawn } = window.require("child_process");
export default {
  data() {
    return {
      downloadInfo: {
        enabled: false,
        copmany: "mediworks",
        btnKey: "login",
        downloadUrl: "http://47.98.209.109:8088/thirdparty_scripts"
      },
      selections: [],
      selectedValue: ""
    };
  },
  mixins: [Message],
  created() {
    reqGet(`${this.downloadInfo.downloadUrl}/company.json`, (err, res) => {
      logStdout("donwload company.json", res);
      if (!err) {
        const result = string2json(res);
        if (result) {
          this.selections = result; // 正式版本
          // this.selections = result.filter(obj => {
          //   return obj.value !== 'jingshi'
          // })
        } else {
          this.message("error");
        }
      }
    });
  },
  mounted() {
    this.downloadInfo = window.settings.thirdparty;
  },
  methods: {
    download() {
      let _error;
      this.confirm(
        this.$t("langcfg.txtClearLastScript"),
        this.$t("langcfg.txtOK"),
        this.$t("langcfg.txtCancel")
      )
        .then(() => {
          this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtDownLoading"));
          logStdout("download script command", fileSys.getUtilPath("download3rdparty.sh"), [
            `${this.downloadInfo.downloadUrl}/${this.downloadInfo.copmany}/`
          ]);
          const sp = spawn(fileSys.getUtilPath("download3rdparty.sh"), [
            `${this.downloadInfo.downloadUrl}/${this.downloadInfo.copmany}/`
          ]);
          sp.on("error", (err) => {
            logStdout("spawn download3rdparty.sh error", err.message);
            _error = ":" + err.message;
          });
          sp.stdout.on("data", (data) => {
            const result = data.toString();
            if (result.indexOf("__error__") >= 0) {
              _error = ":" + result.split(":")[1];
              logStdout("download stdout", result.split(":")[1]);
            }
          });
          sp.on("close", (code) => {
            logStdout("download3rdparty.sh exit code", `${code}`);
            if (
              window.thirdpartyScript &&
              typeof window.thirdpartyScript.clearDownloadTimer === "function"
            ) {
              window.thirdpartyScript.clearDownloadTimer();
            }
            if (code === 0) {
              fileSys.sync();
              initThirdParty();
            }
            this.$emit("thirdparty-checked-changed", false);
            setTimeout(() => {
              this.$bus.$emit(EVENTS.hideGlobalWatting);
              if (code === 0) {
                if (
                  window.thirdpartyScript &&
                  typeof window.thirdpartyScript.getThirdpartyScriptVerison === "function"
                ) {
                  this.message(
                    `${this.$t("langcfg.txtDownloadScriptSuccess")}: ${window.thirdpartyScript.getThirdpartyScriptVerison()}`,
                    "success"
                  );
                }
              } else {
                this.message(
                  `${this.$t("langcfg.txtDownloadScriptFailed")} ${_error || ""}`,
                  "error"
                );
              }
            }, 1000);
          });
        })
        .catch(() => {});
    },
    selectChanged(val) {
      window.settings.thirdparty.copmany = val;
      saveSettings(window.settings);
    },
    handleClick(key) {
      let self = this;

      this.$bus.$emit(EVENTS.spreadKeyBoard, self.downloadInfo[key], (value) => {
        self.downloadInfo[key] = value;
      });
    },
    loginClick() {
      this.$emit("login", this.downloadInfo);
    },
    thirdClick() {
      this.$emit("thirdparty-click", "thirdparty");
    }
  },
  props: {
    loginInfoForm: {
      type: Object,
      default: () => {
        return {
          username: "Admin",
          password: "",
          url: "127.0.0.1:8080",
          ssl: 0
        };
      }
    }
  }
};
</script>
<style lang="less" scoped>
.el-form /deep/ .el-form-item__label {
  font-size: 30px;
  padding: 0px;
  line-height: 50px;
}

/deep/.el-form-item__error {
  margin-left: 20px;
}

.el-form-item {
  line-height: 40px;
  margin-top: 20px;
}

.Login {
  width: 800px;
  padding-left: 20px;
}

.login-tip {
  font-size: 20px;
  width: 100%;
  text-align: left;
  margin-left: 20px;
}

.login-tip-undo {
  color: white;
}

.login-tip-doing {
  color: white;
}

.login-tip-unlogined {
  color: white;
}

.login-tip-failed {
  color: white;
}

.protocol-url {
  display: inline-flex;
  width: 100%;
  margin-left: 20px;
  font-size: 20px;
}

.protocol {
  border: #dcdfe6;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-right: none;
  font-size: 30px;
  background: white;
  outline: none;
  height: 50px;
  color: #606266;
}

.url {
  width: 100%;
  border: none;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-right: none;
  font-size: 30px;
  outline: none;
  height: 50px;
  color: #606266;
}

.btn-oprator {
  border: 1px gray solid;
  height: @header-fs+50px;
}

.btn-oprator:hover {
  color: @btn-hover-color;

  i {
    color: @btn-hover-color;
  }
}
input[type="checkbox"] {
  padding: 0px;
  border: none;
  width: 35px;
  height: 35px;
  margin-left: 30px;
}
.btn-oprator:active {
  background: @btn-active-color;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/FormThirdPartyDownload.vue